/**
 * Hands a generated file to the browser.
 *
 * The object URL is revoked right after the click: it pins the blob in memory for as long
 * as it lives, and these blobs are whole spreadsheets.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
